<template>
  <div
    v-show="active"
    :id="reference"
    :ref="reference"
    class="min-w-screen h-screen animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-30 outline-none focus:outline-none bg-no-repeat bg-center bg-cover"
  >
    <div class="absolute bg-black opacity-80 inset-0 z-0"></div>
    <div class="w-full p-5 relative my-auto rounded-lg shadow-lg bg-white" :class="[size, marginX, isScroll, height]">
      <div :class="wrapClass">
        <!-- header -->
        <slot name="header"></slot>
        <!-- body -->
        <slot></slot>
        <!-- footer -->
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonModal',
  props: {
    reference: {
      type: String,
      default: 'modal',
    },
    active: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'max-w-2xl',
    },
    wrapClass: {
      type: String,
      default: '',
    },
    marginX: {
      type: String,
      default: 'mx-auto',
    },
    isScroll: {
      type: String,
      default: 'overflow-y-scroll',
    },
    height: {
      type: String,
      default: '',
    },
    maxHeight: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>

</style>
